<template>
  <div>
    <div class="bg-gray-900 bg-opacity-60 flex justify-center">
      <div class="w-full sm:mt-4 text-center rounded-lg">
        <section
          class="marginTop flex justify-center bg-white jumbotron-fluid p-2 sm:p-4 bg-faded"
        >
          <div class="sm:w-8/12 p-2">
            <div
              class="flex-shrink px-4 max-w-full w-full  lg:px-6 wow fadeInUp"
              data-wow-duration="1s"
              style="visibility: visible; animation-duration: 1s; animation-name: fadeInUp;"
            >
              <div
                class="sm:py-8 sm:px-8 sm:bg-gray-50 sm:border-b sm:border-gray-100 sm:shadow-md hover:shadow-xl transform transition duration-300 ease-in-out hover:-translate-y-2"
              >
                <div class="inline-block text-gray-900 mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-12 w-12"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                </div>
                <h3
                  class="text-xl sm:text-2xl tracking-tight font-extrabold text-gray-700"
                >
                  Warm Greetings to our clients!
                </h3>
                <p class="text-gray-500">
                  Thank you to all our clients for trusting us with your Real
                  Estate investments! This page is to serve as a quick stop for
                  frequently asked questions and general information that stays
                  the same.
                </p>
              </div>
            </div>
          </div>
        </section>

        <div
          class="text-center bg-gradient-to-r from-gray-800 via-gray-900 to-black"
        >
          <div class="relative py-4 pb-12 sm:p-4">
            <div class="sm:w-8/12 mx-auto">
              <div class="text-center sm:pb-6">
                <div class="pt-4 relative pb-8 bg-white">
                  <div class="sm:w-full mx-auto">
                    <!-- row -->
                    <div class="flex flex-wrap flex-row text-center">
                      <div
                        class="flex-shrink px-4 max-w-full w-full sm:w-1/2 lg:px-6 wow fadeInUp"
                        data-wow-duration="1s"
                        style="visibility: visible; animation-duration: 1s; animation-name: fadeInUp;"
                      >
                        <div
                          class="py-8 px-8 sm:mb-12 mb-4 bg-gray-50 border-b border-gray-100 shadow-md hover:shadow-xl transform transition duration-300 ease-in-out hover:-translate-y-2"
                        >
                          <div class="inline-block text-gray-900 mb-4">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-12 w-12"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                              stroke-width="2"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>
                          </div>
                          <h3
                            class="pb-2 text-xl sm:text-2xl tracking-tight font-extrabold text-gray-700"
                          >
                            Not a 360 Client?
                          </h3>
                          <p class="text-gray-500">
                            We strive to provide the best Real Estate
                            experience! For this reason we interview each new
                            client to determine how our services will best suit
                            you.
                          </p>
                          <button
                            @click="redirect2"
                            type="button"
                            class="inline-flex  items-center px-4 py-1.5 border-solid border-2 border-green-700 text-base font-medium rounded-md shadow-xl text-white bg-green-600 hover:bg-green-800 focus:outline-none"
                          >
                            Contact Us
                          </button>
                        </div>
                      </div>

                      <div
                        class="flex-shrink px-4 max-w-full w-full sm:w-1/2 lg:px-6 wow fadeInUp"
                        data-wow-duration="1s"
                        style="visibility: visible; animation-duration: 1s; animation-name: fadeInUp;"
                      >
                        <div
                          class="py-8 px-8 sm:mb-6 mb-6 bg-gray-50 border-b border-gray-100 shadow-md hover:shadow-xl transform transition duration-300 ease-in-out hover:-translate-y-2"
                        >
                          <div class="inline-block text-gray-900 mb-4">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="2rem"
                              height="2rem"
                              fill="currentColor"
                              class="bi bi-search"
                              viewBox="0 0 16 16"
                            >
                              <path
                                d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
                              ></path>
                            </svg>
                          </div>
                          <h3
                            class="text-xl sm:text-2xl tracking-tight font-extrabold text-gray-700"
                          >
                            News
                          </h3>
                          <p class="text-gray-500">
                            If you are looking for current information about the
                            state of the Harnett County Real Estate market or
                            are want to see current information on a variety of
                            topics visit our "News" page.
                          </p>
                          <button
                            @click="redirect"
                            type="button"
                            class="inline-flex items-center px-4 py-1.5 border-solid border-2 border-green-700 text-base font-medium rounded-md shadow-xl text-white bg-green-600 hover:bg-green-800 focus:outline-none"
                          >
                            News and Blogs
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="sm:py-8 sm:px-16 py-4 px-4 bg-gray-50 border-b border-gray-100 shadow-md hover:shadow-xl transform transition duration-300 ease-in-out hover:-translate-y-2"
                >
                  <h3
                    class="text-xl sm:text-2xl tracking-tight font-extrabold text-gray-700"
                  >
                    What are our standards when helping clients buy or sell a
                    home?
                  </h3>
                  <p class="text-gray-500 mt-2">
                    In terms of home listings for sale - we understand how
                    important it is to keep an active pulse on the market. Here
                    are 360 Real Estate we pride ourselves on keeping up to date
                    with the latest local market trends. We frequently
                    participate in local Chamber of Commerce events as well as
                    Coffee with the Mayor of Spring Lake, Larry Dobbins. Any
                    home listings needs a minumum of two out of these three
                    conditions in order to secure the best sale: (1) Price, (2)
                    Condition, and finally (Features). For example, homes that
                    are in excellent condition and priced accurately spend less
                    time on market! Price is a very motivating factor for
                    home-buyers, but it is equally important to have the home in
                    top condition and highlight any features. Regarding home
                    buyers,our firm speciliazes in representing YOUR needs
                    exclusively. We understand how to advocate and negotiate the
                    best deal for our clients. As experts in the local area we
                    can advise what to look for and ask for when under contract
                    for a home purchase. Having lived in the area for multiple
                    years we have many vendor contacts for services including
                    termite protection, landscaping, fence installation, HVAC
                    services,and plumbing services. We will help you every step
                    of the way in ensuring you are buying a home that is in the
                    best condition possible.
                  </p>
                </div>
              </div>

              <div
                class="sm:py-8 sm:px-16 py-4 px-4  bg-gray-50 border-b border-gray-100 shadow-md hover:shadow-xl transform transition duration-300 ease-in-out hover:-translate-y-2"
              >
                <div class="inline-block text-gray-900">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-12 w-12"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h3
                  class="text-xl sm:text-2xl tracking-tight font-extrabold text-gray-700"
                >
                  Why work with 360 for property management services?
                </h3>
                <p class="text-gray-500 mt-2">
                  In terms of the service we offer, it is our goal to provide an
                  open line of communication with homeowner clients and to
                  maintain the property in a fashion that they would want to
                  move-back into. In order to best achieve this goal - we have
                  implemented three times a year inspections of the interior and
                  exterior of the property scheduled with the tenant in advance.
                  These inspections allow us to keep up with the home and ensure
                  it is being maintained. For example, each Fall we gather of
                  list of homes that need irrigation system winterizations and
                  in the Spring generate a list of homes that require pressure
                  washing / landscaping services. At the time of inspection -
                  tenants sign off on the notes gathered and we share a copy of
                  the report as well. When you secure services with 360 Real
                  Estate we will complete marketing, place tenants, remit rent
                  monies, complete work orders, and maintain a file come tax
                  time to write off expenses associated with the property. We
                  also utilize an online platform (www.vqventure.com) where you
                  can real-time view inquiries, videos, and PDF documents as
                  they pertain to your rental investment.
                </p>
                <v-btn
                  style="border: 2px solid #166534"
                  target="_blank"
                  href="tel:18475046767"
                  color="#16a34a"
                  dark
                >
                  Start Working with 360 Real Estate
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer
      class="text-center text-white bg-gradient-to-r from-gray-800 via-gray-900 to-black"
    >
      <div
        class="text-center p-4"
        style="background-color: rgba(0, 0, 0, 0.2);"
      >
        © 2022 Copyright:
        <a class="text-white" href="https://www.vqventure.com/"
          >Vision Quest Venture</a
        >
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {
    redirect() {
      this.$router.push({ name: "News" });
    },
    redirect2() {
      this.$router.push({ name: "Contact" });
    },
    viewListing() {
      this.$router.push({ name: "listings" });
    }
  }
};
</script>
